import React from 'react';

const MergerStation = () => {
  return (
    <section
      id="about"
      className="self-stretch flex flex-row items-start justify-start pt-[100px] pb-[109.7px] pr-[46px] pl-10 box-border max-w-full text-left text-26xl text-white font-cormorant-garamond mq800:pr-[23px] mq800:pb-[71px] mq800:box-border"
    >
      <div className="flex-1 flex flex-row items-start justify-start gap-[30.2px] max-w-full mq1350:flex-wrap">

        <div
          className="h-[647px] w-[498.8px] flex flex-col items-start justify-start pt-[323.7px] pb-[20px] pr-8 pl-0 box-border gap-[30px] min-w-[498.8px] max-w-full mq800:gap-[15px_30px] mq800:pt-[200px] mq800:box-border mq800:min-w-full mq1125:pt-[210px] mq1125:pb-5 mq1125:box-border mq1350:flex-1 mq1350:pr-0 mq1350:box-border"
        >
          <img
            className="mt-[-324px] self-stretch h-[294px] relative max-w-full overflow-hidden shrink-0 object-cover"
            alt="image 6"
            src="/image-6@2x.png"
          />
          <img
            className="self-stretch h-[293px] relative max-w-full overflow-hidden shrink-0 object-cover"
            alt="image 7"
            src="/image-7@2x.png"
          />
        </div>

        <div
          className="flex-1 flex flex-col items-start justify-start pt-[14.35px] px-0 pb-0 box-border min-w-[536px] max-w-full mq800:min-w-full"
        >
          <div className="self-stretch flex flex-col items-start justify-start gap-[32px] max-w-full mq450:gap-[16px_32px]">
            <div className="flex flex-col items-start justify-start pt-0 px-0 pb-[11px] box-border gap-[6.65px] max-w-full">
              <div className="flex flex-col items-start justify-start gap-[2.7px] max-w-full pb-6">
                <h1
                  className="m-0 relative text-inherit tracking-[0.4px] leading-[58.8px] capitalize font-normal font-inherit inline-block max-w-full mq450:text-8xl mq450:leading-[35px] mq800:text-17xl mq800:leading-[47px]"
                >
                  Добро пожаловать в ICOD-
                </h1>
                <h1
                  className="m-0 h-[55px] relative text-inherit tracking-[0.4px] leading-[58.5px] capitalize font-normal font-inherit inline-block mq450:text-8xl mq450:leading-[35px] mq800:text-17xl mq800:leading-[47px]"
                >
                  Международную юридическую компанию
                </h1>
              </div>
            </div>

            <div
              className="self-stretch relative text-xl tracking-[0.4px] leading-[32px] font-outfit text-lightgray mq450:text-base mq450:leading-[26px]"
            >
              Хотя наша компания базируется в Молдове, наши квалифицированные юристы готовы оказать помощь в области гражданского права, включая выкуп и взыскание долгов, медиацию, финансирование судебных споров и юридический аутсорсинг.
            </div>

            <div
              className="self-stretch flex flex-row items-start justify-start gap-[30px] text-3xl text-lightgray font-outfit mq800:flex-wrap"
            >
              <div
                className="flex-1 bg-darkslategray-200 flex flex-row items-end justify-start pt-[30px] px-[50px] pb-[35px] box-border gap-[20px] min-w-[205px] mq450:flex-wrap mq450:pl-5 mq450:pr-5 mq450:box-border"
              >
                <img
                  className="h-14 w-[58px] relative overflow-hidden shrink-0 z-[1]"
                  alt="icon"
                  src="/image-10.svg"
                />
                <div className="flex-1 flex flex-col items-start justify-end box-border min-w-[89px]">
                  <div className="self-stretch flex flex-col items-start justify-start">
                    <div className="relative tracking-[0.4px] leading-[29px] inline-block min-w-[41px] shrink-0 z-[1] mq450:text-lg mq450:leading-[23px]">
                      95%
                    </div>
                    <div className="h-7 flex flex-row items-start justify-start pt-0 px-0 pb-0 box-border">
                      <div className=" relative tracking-[0.4px] leading-[29px] z-[1] mq450:text-lg mq450:leading-[23px]">
                        Выигранных дел
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="flex-1 bg-burlywood flex flex-row items-start justify-start pt-[30px] px-[50px] pb-[30px] box-border gap-[20px] min-w-[205px] text-gray-300 mq450:flex-wrap mq450:pl-5 mq450:pr-5 mq450:box-border"
              >
                <div className="flex flex-col items-start justify-start pt-1 px-0 pb-0">
                  <button
                    className="cursor-pointer border-none pt-[9px] px-[15px] pb-[11px] bg-gray-400 rounded-8xs flex flex-row items-start justify-start z-[1] hover:bg-darkslategray-100"
                  >
                    <div className="h-[59px] w-[81px] relative rounded-8xs bg-gray-400 hidden" />
                    <div
                      className="relative text-11xl tracking-[0.4px] leading-[39px] font-outfit text-white text-left inline-block min-w-[51px] z-[1] mq450:text-lg mq450:leading-[23px] mq800:text-5xl mq800:leading-[31px]"
                    >
                      20+
                    </div>
                  </button>
                </div>
                <div className="flex-1 flex flex-col items-start justify-start min-w-[73px]">
                  <div className="relative tracking-[0.4px] leading-[29px] inline-block min-w-[56px] shrink-0 z-[1] mq450:text-lg mq450:leading-[23px]">
                    Лет
                  </div>
                  <div className="h-7 flex flex-row items-start justify-start pt-0 px-0 pb-0 box-border">
                    <div className="mt-[-1px] relative tracking-[0.4px] leading-[29px] inline-block min-w-[113px] shrink-0 z-[1] mq450:text-lg mq450:leading-[23px]">
                      Опыта
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MergerStation;
